import { ColumnDef } from '@tanstack/react-table';
import AdvanceTable from 'components/base/AdvanceTable';
import AdvanceTableFooter from 'components/base/AdvanceTableFooter';
import FeatherIcon from 'feather-icons-react';
import { useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import RequestClaimModal from 'components/modals/RequestClaimModal';
import moment from 'moment';
export const tableColumns: ColumnDef<any>[] = [
  {
    accessorKey: 'userId',
    header: 'User ID',
    cell: ({ row: { original } }) => {
      const { userId, id } = original.user
        ? original.user
        : { userId: '', id: '' };
      return (
        <div className="d-flex align-items-center">
          <div>
            <Link to={'/users/' + id + '/details'} className="fs-8 fw-bold">
              {userId}
            </Link>
          </div>
        </div>
      );
    },
    meta: {
      headerProps: {
        style: { width: 'auto' },
        className: 'ps-4 border-start border-end border-translucent ps-0'
      },
      cellProps: {
        className:
          'ps-4 border-start border-end border-translucent white-space-nowrap ps-0'
      }
    }
  },
  {
    accessorKey: 'points',
    header: () => {
      return (
        <div className="d-inline-flex flex-center">
          <div className="px-1 py-1 bg-primary-subtle rounded me-2">
            <FeatherIcon icon="file" size={16} className="text-primary-dark" />
          </div>
          <span>Points</span>
        </div>
      );
    },
    cell: ({ row: { original } }) => {
      const { points } = original;
      return <>{points}</>;
    },
    meta: {
      headerProps: {
        style: { width: 'auto' },
        className: 'ps-4 pe-5 border-end border-translucent'
      },
      cellProps: {
        className:
          'white-space-nowrap fw-semibold ps-4 border-end border-translucent'
      }
    }
  },
  {
    accessorKey: 'tokens',
    header: () => {
      return (
        <div className="d-inline-flex flex-center">
          <div className="px-1 py-1 bg-success-subtle rounded me-2">
            <FeatherIcon icon="mail" size={16} className="text-success-dark" />
          </div>
          <span>Token</span>
        </div>
      );
    },
    cell: ({ row: { original } }) => {
      const { tokens } = original;
      return (
        <div className="d-flex align-items-center">
          <span className="fw-semibold">{tokens}</span>
        </div>
      );
    },
    meta: {
      headerProps: {
        style: { width: 'auto' },
        className: 'ps-4 pe-5 border-end border-translucent'
      },
      cellProps: {
        className:
          'white-space-nowrap fw-semibold ps-4 border-end border-translucent'
      }
    }
  },
  {
    accessorKey: 'burn_tokens',
    header: () => {
      return (
        <div className="d-inline-flex flex-center">
          <div className="px-1 py-1 bg-success-subtle rounded me-2">
            <FeatherIcon icon="mail" size={16} className="text-success-dark" />
          </div>
          <span>Burn Token</span>
        </div>
      );
    },
    cell: ({ row: { original } }) => {
      const { burn_tokens } = original;
      return (
        <div className="d-flex align-items-center">
          <span className="fw-semibold">{burn_tokens}</span>
        </div>
      );
    },
    meta: {
      headerProps: {
        style: { width: 'auto' },
        className: 'ps-4 pe-5 border-end border-translucent'
      },
      cellProps: {
        className:
          'white-space-nowrap fw-semibold ps-4 border-end border-translucent'
      }
    }
  },
  {
    accessorKey: 'pointsType',
    header: () => {
      return (
        <div className="d-inline-flex flex-center">
          <div className="px-1 py-1 bg-success-subtle rounded me-2">
            <FeatherIcon icon="mail" size={16} className="text-success-dark" />
          </div>
          <span>Points Type</span>
        </div>
      );
    },
    cell: ({ row: { original } }) => {
      const { pointsType } = original;
      return (
        <div className="d-flex align-items-center">
          <span className="fw-semibold">{pointsType}</span>
        </div>
      );
    },
    meta: {
      headerProps: {
        style: { width: 'auto' },
        className: 'ps-4 pe-5 border-end border-translucent'
      },
      cellProps: {
        className:
          'white-space-nowrap fw-semibold ps-4 border-end border-translucent'
      }
    }
  },
  {
    accessorKey: 'status',
    header: () => {
      return (
        <div className="d-inline-flex flex-center">
          <div className="px-1 py-1 bg-success-subtle rounded me-2">
            <FeatherIcon icon="mail" size={16} className="text-success-dark" />
          </div>
          <span>Status</span>
        </div>
      );
    },
    cell: ({ row: { original } }) => {
      const { status } = original;
      return (
        <div className="d-flex align-items-center">
          <span className="fw-semibold">{status}</span>
        </div>
      );
    },
    meta: {
      headerProps: {
        style: { width: 'auto' },
        className: 'ps-4 pe-5 border-end border-translucent'
      },
      cellProps: {
        className:
          'white-space-nowrap fw-semibold ps-4 border-end border-translucent'
      }
    }
  },
  {
    accessorKey: 'createdAt',
    header: () => {
      return (
        <div className="d-inline-flex flex-center">
          <div className="px-1 py-1 bg-success-subtle rounded me-2">
            <FeatherIcon icon="mail" size={16} className="text-success-dark" />
          </div>
          <span>Created At</span>
        </div>
      );
    },
    cell: ({ row: { original } }) => {
      const { createdAt } = original;
      return (
        <div className="d-flex align-items-center">
          {/* format date */}
          <span className="fw-semibold">
            {moment(createdAt).format('MM-DD-YYYY h:mm A')}
          </span>
        </div>
      );
    },
    meta: {
      headerProps: {
        style: { width: 'auto' },
        className: 'ps-4 pe-5 border-end border-translucent'
      },
      cellProps: {
        className:
          'white-space-nowrap fw-semibold ps-4 border-end border-translucent'
      }
    }
  }
];

const RewardClaimHistoryTable = () => {
  return (
    <div className="border-top border-translucent">
      <AdvanceTable
        tableProps={{ className: 'phoenix-table fs-9' }}
        rowClassName="hover-actions-trigger btn-reveal-trigger"
      />
      <AdvanceTableFooter pagination className="py-4" />
    </div>
  );
};

export default RewardClaimHistoryTable;
